export default __webpack_public_path__ + "static/media/Roboto-Light.d537674e.woff2";